import actionTypes from '../actions/action-types';
import { SET_CATEGORIES, SET_FILES, SET_IS_LOADING, SET_TAGS } from '../actions/documents.actions';

const initialState = {
  newLabel: false,
  categories: [],
  files: [],
  tags: [],
  isLoading: false,
  meta: {},
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_CATEGORIES:
      return Object.assign({}, state, {
        categories: action.payload,
      });
    case actionTypes.FETCH_NEW_LABEL_STATUS_SUCCESS:
    case actionTypes.SET_NEW_LABEL_STATUS_SUCCESS:
      return {
        ...state,
        newLabel: action.status,
      };
    case SET_TAGS:
      return Object.assign({}, state, {
        tags: action.payload,
      });
    case SET_FILES: {
      return Object.assign({}, state, {
        files: action.payload.documents || [],
        meta: action.payload.meta || {},
        isLoading: false,
      });
    }
    case SET_IS_LOADING:
      return Object.assign({}, state, {
        isLoading: action.payload,
      });
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/modules/documents/reducers/documents.reducer.js